/**
 * 查看字典
 */
export const DICT_LIST_PAGE_UUID = 'bccd3092-4ac6-407b-8579-bfc4cf52cec9'

/**
 * 管理字典
 */
export const DICT_ACTION_UUID = '4498212c-79ab-443a-8786-32f6bf2003fe'
